export interface sportInterface {
  name: string;
  iconActived: string;
  iconDeactived: string;
  active: boolean;
  mouseOn: boolean;
}

export const sport: Array<sportInterface> = [
  {
    name: 'SPORT.ride.title',
    iconActived: 'assets/images/svg/whiteRide.svg',
    iconDeactived: 'assets/images/svg/greyRide.svg',
    active: true,
    mouseOn: false,
  },
  {
    name: 'SPORT.run.title',
    iconActived: 'assets/images/svg/whiteRun.svg',
    iconDeactived: 'assets/images/svg/greyRun.svg',
    active: false,
    mouseOn: false,
  },
  {
    name: 'SPORT.row.title',
    iconActived: 'assets/images/svg/whiteRow.svg',
    iconDeactived: 'assets/images/svg/greyRow.svg',
    active: false,
    mouseOn: false,
  },
];
